import React from "react";
import { Checkbox, Typography } from "@material-ui/core";
import TextEditor from "@icarius-common/textEditor";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import { getLocalizedString } from "@icarius-localization/strings";
import Container from "@icarius-pages/myTraining/components/container";
import StatusChip from "../../../mainContent/statusChip";

const EvaluationResolution = (props) => {

  const {
    readOnly,
    resolution,
    descriptiveCorrection,
    handleSetDescriptiveCorrectionValue,
  } = props;

  if (!resolution.questions?.length) return null;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      {
        resolution.questions.map((question, questionIndex) => {
          return (
            <Container
              key={questionIndex}
              title={`${getLocalizedString("question")} ${questionIndex + 1}:`}
            >
              <StatusChip
                passed={question.isCorrect}
                isExercise
                showIcon
              />
              <div
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <TextEditor
                  initialValue={question.text}
                  maxHeight={"100%"}
                  disabled
                />
              </div>
              {
                (question.options || []).map((option, optionIndex) => {
                  const isMarkedByParticipant = (() => {
                    if (question.type === "U") return question.answer === optionIndex;
                    return question.answer.includes(optionIndex);
                  })();

                  const isCorrectOption = (() => {
                    if (question.type === "U") return question.correctAnswer === optionIndex;
                    return question.correctAnswer.includes(optionIndex);
                  })();

                  const optionColor = (() => {
                    if (isMarkedByParticipant && isCorrectOption) return "var(--ownGreen)";
                    if (isMarkedByParticipant && !isCorrectOption) return "var(--ownRed)";
                    if (!isMarkedByParticipant && isCorrectOption) return "var(--ownOrange)";
                    return "";
                  })();

                  return (
                    <Typography
                      key={optionIndex}
                      style={{
                        fontSize: 14,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        checked={isMarkedByParticipant || isCorrectOption}
                        style={{
                          color: optionColor,
                          cursor: "default",
                        }}
                      />
                      {option}
                    </Typography>
                  )
                })
              }
              {
                Boolean(question.options?.length) &&
                <div
                  style={{
                    padding: 20,
                    paddingBottom: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: "10px 30px",
                  }}
                >
                  {
                    [
                      { color: "var(--ownGreen)", label: getLocalizedString("correctAnswer") },
                      { color: "var(--ownOrange)", label: getLocalizedString("correctUnpickedAnswer") },
                      { color: "var(--ownRed)", label: getLocalizedString("incorrectAnswer") },
                    ].map((item, itemIndex) => {
                      return (
                        <div
                          key={itemIndex}
                          style={{
                            display: "flex",
                            gap: 10,
                          }}
                        >
                          <div style={{ height: 18, width: 18, borderRadius: 4, background: item.color }} />
                          <Typography variant="caption">{item.label}</Typography>
                        </div>
                      )
                    })
                  }
                </div>
              }
              {
                question.type === "D" &&
                <>
                  <TextFieldMultiline
                    disabled
                    fullWidth
                    label={getLocalizedString("answer")}
                    rows={3}
                    margin={"none"}
                    value={question.answer}
                    inputProps={{ spellCheck: 'false' }}
                  />
                  {
                    !readOnly &&
                    <Typography
                      onClick={() => handleSetDescriptiveCorrectionValue(questionIndex)}
                      style={{
                        marginTop: 10,
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Checkbox
                        checked={descriptiveCorrection[questionIndex] || false}
                        style={{ color: "var(--mainText)" }}
                      />
                      {getLocalizedString("correct")}
                    </Typography>
                  }
                </>
              }
            </Container>
          )
        })
      }
    </div>
  );
}

export default EvaluationResolution;